<template>
  <div class="LKProfileAvatar">
    <v-avatar class="LKProfileAvatar__avatar">
      <v-img v-if="imageUrl" :src="imageUrl" />
      <span v-else class="white--text text-h5">{{ nameInitials }}</span>
    </v-avatar>
    <label>
      <v-btn
        outlined
        color="indigo"
        class="LKProfileAvatar__btn"
        :loading="imageUploading"
        @click="$refs.fileInput.click()"
      >
        новое фото
      </v-btn>
      <input
        v-show="false"
        ref="fileInput"
        type="file"
        accept="image/*"
        @change="onChange"
      >
    </label>
  </div>
</template>

<script>
export default {
  name: 'LKProfileAvatar',
  props: {
    fullName: {
      type: String,
      required: true,
    },
    imageUrl: {
      type: String,
      default: '',
    },
    imageUploading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    nameInitials() {
      return this.fullName.split(' ').map((word) => word[0].toUpperCase()).slice(0, 2).join('')
    },
  },
  methods: {
    onChange(e) {
      const file = e.target.files?.[0]
      if (!file) return

      this.$emit('change', file)
      e.target.value = ''
    },
  },
}
</script>

<style lang="scss">
.LKProfileAvatar {
  &__avatar {
    background-color: $webflow-color-alert-line;
  }

  &__btn {
    margin-left: 10px;
  }
}
</style>
